import React, { useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;

export default function PostMaterial() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user")); // 👈 get teacher from localStorage
  const teacherId = user?.id || ""; // You might also use user._id depending on backend

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    if (!file || !title || !description) {
      setMessage("All fields and file are required.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("material", file);
    formData.append("teacherId", teacherId); // 👈 Add teacher ID

    try {
      const res = await fetch(`${API_URL}/api/teacher/materials`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.error || "Upload failed");
      } else {
        setMessage("✅ Material uploaded successfully");
        setTitle("");
        setDescription("");
        setFile(null);
      }
    } catch (err) {
      setMessage("Server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">📤 Post Teaching Material</h2>

        {message && (
          <p className="mb-4 text-center text-sm bg-blue-100 text-blue-800 rounded-md py-2 px-4">
            {message}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="hidden" name="teacherId" value={teacherId} />

          <div>
            <label className="block font-medium mb-1">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-lg"
              rows="4"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Upload File</label>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.ppt,.pptx"
              onChange={(e) => setFile(e.target.files[0])}
              required
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg font-semibold ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {loading ? "Uploading..." : "Upload Material"}
          </button>
        </form>
      </div>
    </div>
  );
}
